import { render, staticRenderFns } from "./Nurseries.vue?vue&type=template&id=a2020326"
import script from "./Nurseries.vue?vue&type=script&lang=js"
export * from "./Nurseries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports